import React from 'react';

const Marquee = () => {
  const text = 'CANADA BASED • RESEARCH FOCUSED • DISCREET SHIPPING • FOR RESEARCH USE ONLY • ';
  return (
    <div className="overflow-hidden bg-[#0a0a0b] border-b border-white/5">
      <div className="marquee-track py-2">
        {Array.from({ length: 2 }).map((_, i) => (
          <span key={i} className="font-mono-label text-[11px] text-[#ff2fa1]/80 shrink-0 pr-6">
            {text.repeat(10)}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
